<template>
  <DetailInfo :btnList="btnList">
    <div class="activity-tracker-container">
      <CollapseContent
        v-if="!candidateBaseInfo.is_agency_uploaded_and_hid && !needHiddenActivity && !isAgency"
        class="comment"
        :title="$t(`${i18nPrefix}.title.comment`)"
      >
        <template #suffix>
          <div class="private-switch" @click.stop>
            <span class="label">{{ $t(`${i18nPrefix}.label.myComment`) }}</span>
            <el-switch v-model="isMyComment" @change="handleMyCommentChange"></el-switch>
          </div>
        </template>
        <div
          v-for="(item) in filteredCommentList"
          class="content-container comment-info"
          :key="item.id"
        >
          <div class="info">
            <div class="name">{{ item.created_account }}</div>
            <div v-if="item.job" class="job">
              <span class="label">{{ $t(`${i18nPrefix}.label.job`) }}: </span>
              <span class="content">{{ item.job.i18nName }}</span>
            </div>
            <div v-if="item.statusChangeText" class="status">
              <span class="label">{{ $t(`${i18nPrefix}.label.candidateStatus`) }}: </span>
              <span class="content">{{ item.statusChangeText }}</span>
            </div>
            <div v-if="item.cause" class="cause">
              <span class="label">{{ $t(`${i18nPrefix}.label.cause`) }}: </span>
              <span class="content">{{ item.cause.i18nName }}</span>
            </div>
            <template v-if="item.comment">
              <div v-if="item.type === TAGGED_SOURCE_CHANGE_COMMENT_TYPE" class="source">
                <span class="label">{{ $t(`${i18nPrefix}.label.activitySource`) }}: </span>
                <span class="content">{{ item.comment }}</span>
              </div>
              <div v-else-if="shouldUseI18nComment(item)" class="source">
                <span class="content">{{ formatI18nComment(item.comment) }}</span>
              </div>
              <div v-else class="comment">
                <span class="label">{{ $t(`${i18nPrefix}.label.comments`) }}: </span>
                <span class="content">{{ item.comment }}</span>
              </div>
            </template>
          </div>
          <div class="time">{{  item.created_time|formatDateTime('YYYY/MM/DD HH:mm')  }}</div>
        </div>
      </CollapseContent>
      <CollapseContent v-if="!candidateBaseInfo.is_agency_uploaded_and_hid && candidate_applied_jobs.length > 0 && !needHiddenActivity" class="applied-job-history" :title="$t(`${i18nPrefix}.title.appliedJobHistory`)">
        <div v-for="(item, index) in appliedInfoList" :key="index" class="content-container">
          <span
            v-if="candidateBaseInfo.job && item.job && candidateBaseInfo.job.id === item.job.id"
            class="content-item current-job"
            :title="item.job.i18nName"
          >
            {{ item.job.i18nName }}
          </span>
          <span v-else class="job content-item" :title="item.job.i18nName" @click="openDetail(item)">{{ item.job.i18nName }}</span>
          <span class="company content-item" :title="item.company.i18nName">{{ item.company.i18nName }}</span>
          <span class="status content-item" :title="item.status.i18nName">{{ item.status.i18nName }}</span>
          <span class="date content-item">{{ item.apply_time|formatDateTime('YYYY/MM/DD HH:mm') }}</span>
        </div>
      </CollapseContent>
      <CollapseContent v-if="hasContactRecordList && !needHiddenActivity && !isAgency" class="contact-history" :title="$t(`${i18nPrefix}.title.contact`)">
        <div v-for="(record, index) in contact_history" class="contact-record" :key="index">
          <div class="contact-info">
            <div class="info-item name">{{ record.sender.full_name }}</div>
            <!-- TODO hide job in application profile page -->
            <!-- <div class="info-item job">
              <div class="label">{{ $t(`${i18nPrefix}.label.job`) }}:</div>
              <div class="content">{{ jobName }}</div>
            </div> -->
            <div class="info-item title">
              <span class="item-label">{{ $t(`${i18nPrefix}.label.emailSubject`) }}: </span>
              <span class="item-content">{{ record.email_subject }}</span>
            </div>
          </div>
          <div class="time">{{ record.created_time|formatDateTime('YYYY/MM/DD HH:mm') }}</div>
        </div>
      </CollapseContent>
      <CollapseContent v-if="showCandidateActivity" class="candidate-activity" :title="$t(`${i18nPrefix}.title.candidateActivity`)">
        <el-collapse>
          <el-collapse-item
            v-for="(monthActivity, month) in candidateActivity"
            class="month"
            :key="month"
            :name="`monthlyActivity_${month}`"
          >
            <template #title>
              <div class="title time-title">
                <i class="el-icon-caret-right"></i>
                <span class="date">{{ month }}</span>
              </div>
              <div class="count">
                <span class="label">{{ $t(`${i18nPrefix}.label.activity`) }}: </span>
                <span class="content">{{ monthActivity.count }}</span>
              </div>
            </template>
            <el-collapse-item
              v-for="(dayActivityList, day) in monthActivity.dailyActivityList"
              class="activity-container"
              :key="day"
              :name="`monthlyActivity_${month}_activity_${day}`"
            >
              <template #title>
                <div class="title time-title">
                  <i class="el-icon-caret-right"></i>
                  <span class="date">{{ day }}</span>
                </div>
                <div class="count">
                  <span class="label">{{ $t(`${i18nPrefix}.label.activity`) }}: </span>
                  <span class="content">{{ dayActivityList.length }}</span>
                </div>
              </template>
              <TimeLine :activities="dayActivityList" />
            </el-collapse-item>
          </el-collapse-item>
        </el-collapse>
      </CollapseContent>
      <CollapseContent v-if="hasGroupRecordList && !needHiddenActivity" class="group-history" :title="$t(`${i18nPrefix}.title.groupRecord`)">
        <div v-for="(record, index) in group_history" class="group-record" :key="index">
          <div class="group-info">
            <div class="info-item name">{{ record.operator }}</div>
            <div v-if="record.job_name" class="info-item job">
              <span class="label">{{ $t(`${i18nPrefix}.label.job`) }}: </span>
              <span class="content">{{ record.job_name }}</span>
            </div>
            <div class="info-item operation">
              <span class="label">{{ $t(`${i18nPrefix}.label.operation`) }}: </span>
              <span class="content">{{ getOperationLabel(record.operation) }}</span>
            </div>
            <div v-if="record.operation !== 'A'" class="info-item from-group">
              <span class="label">{{ $t(`${i18nPrefix}.label.fromGroup`) }}: </span>
              <span class="content">{{ record.operation === 'M' ? record.from_group.text : record.target_group.text }}</span>
            </div>
            <div v-if="record.operation !== 'R'" class="info-item to-group">
              <span class="label">{{ $t(`${i18nPrefix}.label.toGroup`) }}: </span>
              <span class="content">{{ record.target_group.text }}</span>
            </div>
            <div v-if="record.comment" class="info-item comment">
              <span class="label">{{ $t(`${i18nPrefix}.label.comment`) }}: </span>
              <span class="content">{{ record.comment }}</span>
            </div>
          </div>
          <div class="time">{{ record.created_time|formatDateTime('YYYY/MM/DD HH:mm') }}</div>
        </div>
      </CollapseContent>
    </div>
    <AddComment
      v-if="!needHiddenActivity && !isAgency"
      ref="addCommentDialog"
      :jobId="jobId"
      :candidateId="candidateId"
      :isTalentPool="isTalentPool"
      :showInterviewerCanView="showInterviewerCanView"
      @added="onCommentAdded"
    />
  </DetailInfo>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { addI18nProperty, getI18nPropertyValue } from '@/i18n'
import DetailInfo from './components/detailInfo.vue'
import TimeLine from './components/timeLine.vue'
import AddComment from './dialog/addComment.vue'
import CollapseContent from './components/collapseContent.vue'
import { mapGetters, mapActions } from 'vuex'

const TAGGED_SOURCE_CHANGE_COMMENT_TYPE = 1
const MANUALLY_ADDING_COMMENT_TYPE = 2
const HR_MANUALLY_INVITE_CANDIDATE_TO_AGREE_CONSENT_COMMENT_TYPE = 7
const I18N_COMMENT_LIST = [
  'Updated by rating result/基于评估结果更新',
  'Updated by interview result/基于面试结果更新'
]

export default {
  components: {
    DetailInfo,
    TimeLine,
    CollapseContent,
    AddComment
  },
  props: {
    candidateBaseInfo: {
      required: true
    },
    isTalentPool: {
      type: Boolean,
      default: false
    },
    isPotential: {
      type: Boolean,
      default: false
    },
    isAgency: {
      type: Boolean,
      default: false
    },
    isAcceptAgencyUploadedCandidate: {
      type: Boolean,
      default: false
    },
    showInterviewerCanView: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    prefetchedActivityData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      getI18nPropertyValue,
      moment,
      i18nPrefix: 'admin.application.candidate',
      activeNames: ['comment', 'appliedJobHistory', 'candidateActivity'],
      TAGGED_SOURCE_CHANGE_COMMENT_TYPE,
      HR_MANUALLY_INVITE_CANDIDATE_TO_AGREE_CONSENT_COMMENT_TYPE,
      appliedJobHistory: null,
      candidate_applied_jobs: [],
      candidate_applicant_history_list: [],
      contact_history: [],
      group_history: [],
      candidate_activity: [],
      comments: [],
      filteredCommentList: [],
      isMyComment: false
    }
  },
  computed: {
    needHiddenActivity () {
      if (this.isPotential) {
        return !this.isTalentPool
      }
      return false
    },
    candidateId () {
      return this.candidateBaseInfo.id
    },
    jobId () {
      return this.candidateBaseInfo.job?.id
    },
    jobName () {
      return this.candidateBaseInfo.job.i18nName
    },
    showCandidateActivity () {
      return this.hasAnyPermission('PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT') && this.candidate_activity.length > 0
    },
    hasContactRecordList () {
      return this.contact_history.length > 0
    },
    hasGroupRecordList () {
      return this.group_history.length > 0
    },
    candidateActivity () {
      const monthlyActivity = _.groupBy(this.candidate_activity, (item) => moment(item.created_time).format('YYYY/MM'))
      const candidateActivity = {}
      _.forEach(monthlyActivity, (monthActivityList, month) => {
        candidateActivity[month] = {
          count: monthActivityList.length,
          dailyActivityList: _.groupBy(monthActivityList, item => moment(item.created_time).format('YYYY/MM/DD'))
        }
      })
      return candidateActivity
    },
    commentList () {
      // 潜在候选人(isPotential=true)：存在 candidate信息时（isTalentPool=true），直接显示candidate的相关信息；
      // 反之不显示，并没有candidate_applicant_history_list数据
      if (!this.isTalentPool) {
        return _
          .chain(this.candidate_applicant_history_list)
          .filter(item => item.comment || (item.status && item.old_status))
          .map(item => {
            addI18nProperty(item.job, 'i18nName', 'cn_title', 'title')
            if (item.cause) {
              addI18nProperty(item.cause, 'i18nName', 'cause_cn', 'cause_en')
            }
            if (item.status && item.old_status) {
              Object.defineProperty(item, 'statusChangeText', {
                configurable: true,
                enumerable: true,
                get () {
                  const statusText = getI18nPropertyValue(item.status, 'name_cn', 'name_en')
                  const oldStatusText = getI18nPropertyValue(item.old_status, 'name_cn', 'name_en')
                  return `${oldStatusText} -> ${statusText}`
                }
              })
            }
            return item
          })
          .value()
      } else {
        return _
          .chain(this.comments)
          .map(item => {
            item.created_account = item.creator?.full_name
            return item
          })
          .value()
      }
    },
    appliedInfoList () {
      return _.chain(this.candidate_applied_jobs).map(item => {
        addI18nProperty(item.job, 'i18nName', 'cn_name', 'name')
        addI18nProperty(item.company, 'i18nName', 'cn_name', 'name')
        addI18nProperty(item.status, 'i18nName', 'name_cn', 'name_en')
        return item
      }).value()
    },
    btnList () {
      const vm = this
      const list = [
        {
          hidden: this.isAgency || (this.candidateBaseInfo.is_agency_uploaded_and_hid && !this.isAcceptAgencyUploadedCandidate),
          label: this.$t(`${this.i18nPrefix}.btn.addComment`),
          onclick: this.handleAddComment
        }
      ]
      _.forEach(list, item => {
        Object.defineProperty(item, 'disabled', {
          enumerable: true,
          configurable: true,
          get () {
            return vm.isDisabled
          }
        })
        Object.defineProperty(item, 'tooltip', {
          enumerable: true,
          configurable: true,
          get () {
            return vm.isDisabled && vm.$t(`${vm.i18nPrefix}.message.disabledTip`)
          }
        })
      })
      return _.filter(list, item => !item.hidden)
    }
  },
  watch: {
    commentList: {
      handler (newVal) {
        this.filteredCommentList = [...newVal]
      },
      immediate: true
    },
    prefetchedActivityData: {
      handler (newVal) {
        if (newVal) {
          this.applyActivityData(newVal)
        }
      },
      immediate: true
    }
  },
  created () {
    if (!this.prefetchedActivityData) {
      this.loadApplicationCandidateActivityInfo()
    }
  },
  methods: {
    ...mapActions('application', ['getApplicationCandidateActivityInfo']),
    ...mapActions('talent', ['getTalentCandidateActivityInfo']),
    ...mapActions('potential', ['getPotentialCandidateActivityInfo']),
    ...mapGetters('account', ['getCurrentAccount']),
    shouldUseI18nComment (item) {
      return item.type === HR_MANUALLY_INVITE_CANDIDATE_TO_AGREE_CONSENT_COMMENT_TYPE || I18N_COMMENT_LIST.includes(item.comment)
    },
    formatI18nComment (comment) {
      const comments = _.split(comment, '/')
      const commentEn = comments[0]
      const commentCn = comments[1]
      if (this.$i18n.locale === 'en') {
        return commentEn
      } else {
        return commentCn
      }
    },
    applyActivityData (resp) {
      this.candidate_applied_jobs = resp.candidate_applied_jobs || []
      this.candidate_applicant_history_list = resp.candidate_applicant_history_list || []
      this.comments = resp.comments || []
      this.contact_history = resp.contact_history || []
      this.group_history = resp.group_history || []
      this.candidate_activity = resp.candidate_activity || []
    },
    async loadApplicationCandidateActivityInfo () {
      if (this.isPotential) {
        const resp = await this.getPotentialCandidateActivityInfo({ potentialId: this.candidateBaseInfo.potential_id })
        if (resp) {
          // 潜在候选人(isPotential=true)：存在 candidate信息时（isTalentPool=true），直接显示candidate的相关信息；
          // 反之不显示，并没有candidate_applicant_history_list数据
          this.candidate_applied_jobs = resp.candidate_applied_jobs
          this.comments = resp.comments
          this.contact_history = resp.contact_history
          this.group_history = resp.group_history
          this.candidate_activity = resp.candidate_activity
          this.applyActivityData(resp)
        }
      } else if (this.isTalentPool) {
        const resp = await this.getTalentCandidateActivityInfo({ candidateId: this.candidateId })
        if (resp) {
          this.applyActivityData(resp)
        }
      } else {
        const params = {
          job_id: this.jobId,
          candidate_id: this.candidateId
        }
        const resp = await this.getApplicationCandidateActivityInfo(params)
        if (resp) {
          this.applyActivityData(resp)
        }
      }
    },
    getOperationLabel (operation) {
      let i18nKey = ''
      if (operation === 'A') {
        i18nKey = 'add'
      } else if (operation === 'M') {
        i18nKey = 'move'
      } else if (operation === 'R') {
        i18nKey = 'remove'
      }
      return i18nKey && this.$t(`common.btn.${i18nKey}`)
    },
    handleAddComment () {
      this.$eventBus.$emit('showCollapseInfo', 'comment')
    },
    onCommentAdded (comment) {
      if (this.isTalentPool) {
        const commentList = this.comments
        const currentAccount = this.getCurrentAccount()
        commentList.splice(0, 0, {
          created_time: new Date(),
          created_account: currentAccount.full_name,
          created_account_id: currentAccount.id,
          creator: {
            full_name: currentAccount.full_name
          },
          comment: comment,
          type: MANUALLY_ADDING_COMMENT_TYPE
        })
      } else if (!this.isPotential) {
        const commentList = this.candidate_applicant_history_list
        const currentAccount = this.getCurrentAccount()
        commentList.splice(0, 0, {
          created_time: new Date(),
          created_account: currentAccount.full_name,
          created_account_id: currentAccount.id,
          job: addI18nProperty({
            ...this.candidateBaseInfo.job
          }, 'i18nName', 'cn_title', 'title'),
          comment: comment,
          type: MANUALLY_ADDING_COMMENT_TYPE
        })
      }
    },
    openDetail (application) {
      let url = ''
      if (this.isAgency) {
        const backUrl = encodeURIComponent(`/v-agency/job/${application.job.id}/application/`)
        url = `/v-admin/agency/application/profile?candidate_id=${this.candidateId}&job_id=${application.job.id}&back=${backUrl}`
      } else {
        const backUrl = encodeURIComponent(`/v-admin/job/${application.job.id}/application/`)
        url = `/v-admin/application/profile?candidate_id=${this.candidateId}&job_id=${application.job.id}&back=${backUrl}`
      }
      window.open(url)
    },
    handleMyCommentChange (isMyComment) {
      const currentAccount = this.getCurrentAccount()
      this.$eventBus.$emit('changeIsMyCommentsStatus', isMyComment)
      if (isMyComment) {
        this.filteredCommentList = _.filter(this.commentList, item => item.created_account_id === currentAccount.id)
      } else {
        this.filteredCommentList = [...this.commentList]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-tracker-container {
  max-width: 910px;
  margin: 0 auto;
  border-top: 0;

  .comment {
    .private-switch {
      margin-left: auto;
      font-size: 14px;
      font-weight: normal;
      cursor: initial;

      .label {
        margin-right: 10px;
        height: 20px;
        line-height: 20px;
      }
    }

    .comment-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .info {
        line-height: 25px;
        .comment {
          .content {
            white-space: pre-wrap;
          }
        }
      }
      .time {
        flex-shrink: 0;
        margin-left: 20px;
      }
    }
  }

  .candidate-activity {
    .el-collapse {
      border: 0;

      .el-collapse-item {
        ::v-deep .el-collapse-item__header {
          border-bottom: 0;

          .title {
            font-weight: bold;

            &.time-title {
              font-weight: normal;
            }
          }

          .count {
            margin-left: auto;
            color: #0096CC;
            font-weight: bold;
          }
        }
      }

      .month {
        ::v-deep .el-collapse-item__header {
          font-size: 14px;
          border-bottom: 0;

          .title {
            .el-icon-caret-right {
              font-size: 16px;
              margin-right: 10px;
              color: #909399;
              transition: all .3s;
            }
          }

          &.is-active {
            .title {
              .el-icon-caret-right {
                transform: rotate(90deg);
              }
            }
          }

          .el-collapse-item__arrow {
            display: none;
          }
        }

        ::v-deep .el-collapse-item__wrap {
          border-bottom: 0;

          .el-collapse-item__content {
            padding-bottom: 0;
            padding-left: 20px;
          }
        }
      }
    }
  }

  .applied-job-history {
    .content-container {
      .content-item {
        display: inline-block;
        width: 28%;
        padding-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.job {
          padding-left: 0;
          color: #0096CC;
          cursor: pointer;
        }

        &.current-job {
          padding-left: 0;
        }

        &.date {
          width: 16%;
          text-align: right;
        }
      }
    }
  }

  .contact-history {
    .contact-record {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #606266;
      font-size: 14px;
      border-bottom: 1px solid #EBEEF5;
      padding: 15px 0;

      .info-item {
        line-height: 20px;

        &.name {
          margin-bottom: 4px;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }

  .group-history {
    .group-record {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #606266;
      font-size: 14px;
      border-bottom: 1px solid #EBEEF5;
      padding: 15px 0;

      .info-item {
        line-height: 20px;

        &.name {
          margin-bottom: 4px;
          font-size: 16px;
          font-weight: bold;
        }

        &.comment {
          .content {
            white-space: pre-wrap;
          }
        }
      }

      .time {
        flex-shrink: 0;
        margin-left: 20px;
      }
    }
  }

  .content-container {
    color: #606266;
    font-size: 14px;
    border-bottom: 1px solid #EBEEF5;
    padding: 15px 0;

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }

    .name {
      margin-bottom: 4px;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
